import { CSSProperties } from 'react'

const styles = {
  container: {
    padding: 25,
    gap: 20,
    justifyContent: 'center'
  } as CSSProperties,
  textField: {
    width: 400
  } as CSSProperties,
  carouselItem: {
    paddingRight: 40
  } as CSSProperties,
  productImage: {
    width: '100%',
    height: '100%',
    position: 'relative',
    borderRadius: 10
  } as CSSProperties,
  logoutBtn: {
    minWidth: 80,
    float: 'right',
    backgroundColor: '#22bcca',
    color: '#000'
  } as CSSProperties,
  savedArticlesBtn: {
    minWidth: 80,
    backgroundColor: 'transparent',
    color: '#22bcca',
    borderColor: '#22bcca',
    '&:hover': {
      backgroundColor: 'rgba(34, 188, 202, 0.04)',
      borderColor: '#22bcca'
    }
  } as CSSProperties,
  filterContainer: {
    display: 'flex',
    gap: 20,
    flexDirection: 'column',
    alignItems: 'flex-start'
  } as CSSProperties,
  loadingContainer: {
    display: "flex",
    alignContent: "center",
    height: "100vh",
    justifyContent: "center",
  }
}

export default styles
